import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

type BeginDesktopSignInResult = {
  code: string;
};

export const beginDesktopSignIn = async (
  challenge: string,
): Promise<string> => {
  const functions = getFunctions();
  const begin = httpsCallable<{ challenge: string }, BeginDesktopSignInResult>(
    functions,
    'users-beginDesktopSignIn',
  );

  const { data } = await begin({ challenge });

  return data.code;
};
